module.exports = __webpack_public_path__ + "img/hong1.1015854c.png";